// extracted by mini-css-extract-plugin
module.exports = {"copyToClipboard":"CopyLink_copyToClipboard__2ZYvv","link":"CopyLink_link__Z7GQH","icon":"CopyLink_icon__Jvz-D","iconInner":"CopyLink_iconInner__2F4Wx"};